import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ImageUploader } from "@/components/ui/image-uploader";

export default function SingleMediaConfigForm({
  config,
  onUpdate,
  widgetId,
  spaceId,
}) {
  const isVideo = config.media?.url?.match(/\.(mp4|webm|ogg)($|\?)/i);

  const updateMedia = (field, value) => {
    if (typeof onUpdate !== "function") {
      console.error("onUpdate is not a function", { onUpdate });
      return;
    }
    const newMedia = { ...(config.media || {}), [field]: value };
    onUpdate({ media: newMedia });
  };

  return (
    <div className="space-y-4 w-full">
      <div>
        <Label className="text-white mb-2">{isVideo ? "Video" : "Image"}</Label>
        <ImageUploader
          value={config.media?.url}
          onChange={(newValue) => {
            // Handle both string and object values from ImageUploader
            if (typeof newValue === "string") {
              updateMedia("url", newValue);
            } else {
              onUpdate?.({
                media: {
                  ...(config.media || {}),
                  ...newValue,
                },
              });
            }
          }}
          widgetId={widgetId}
          spaceId={spaceId}
          acceptMedia={true}
        />
      </div>

      <div>
        <Label className="text-white">Caption</Label>
        <Input
          value={config.media?.caption || ""}
          onChange={(e) => updateMedia("caption", e.target.value)}
          placeholder={isVideo ? "Video caption" : "Image caption"}
          className="bg-white/5 border-white/10 text-white placeholder:text-white/50"
        />
      </div>

      {!isVideo && (
        <div>
          <Label className="text-white">Alt Text</Label>
          <Input
            value={config.media?.alt_text || ""}
            onChange={(e) => updateMedia("alt_text", e.target.value)}
            placeholder="Image alt text for accessibility"
            className="bg-white/5 border-white/10 text-white placeholder:text-white/50"
          />
        </div>
      )}
    </div>
  );
}
